import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Color, ColorVariants } from "@medapro-types/common/common";
import { computed } from "vue";
import { vSafeClass } from "@/plugins/directives/safeDirectives";

export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    icon: { default: "WIP-Placeholder-Icon" },
    variant: {},
    size: { default: "16px" },
    color: {},
    coreUi: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const classList = computed(() => {
  const result = [];

  if (!props.icon || "WIP-Placeholder-Icon" == props.icon || "WIP" == props.icon) {
    result.push(`mdp-WIP-Placeholder-Icon`);
    result.push(`text-debug`);
  } else {
    if (props.variant) result.push(`text-${props.variant}`);
    if (props.coreUi) result.push(`cil-${props.icon}`);
    else result.push(`mdp-${props.icon}`);
  }
  return result;
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("i", {
    class: "icon",
    style: _normalizeStyle({ 'font-size': props.size, color: props.color })
  }, null, 4)), [
    [_unref(vSafeClass), classList.value]
  ])
}
}

})